import { markRaw } from 'vue'
import ClassificationUsageGraphqlFilter from './hires/ClassificationUsageGraphqlFilter.vue'
import WorkerPayoutStatusGraphqlFilter from './payment-requests/WorkerPayoutStatusGraphqlFilter.vue'
import PaymentRequestTypeGraphqlFilter from './payment-requests/RequestTypeGraphqlFilter.vue'
import PaymentRequestStatusGraphqlFilter from './payment-requests/StatusGraphqlFilter.vue'
import ClientsGraphqlFilter from './payment-requests/ClientsGraphqlFilter.vue'
import HasTimesheetGraphqlFilter from './payment-requests/HasTimesheetGraphqlFilter.vue'
import HasPurchaseOrderNumberGraphqlFilter from './payment-requests/HasPurchaseOrderNumberGraphqlFilter.vue'
import CountriesGraphqlFilter from './trustedContacts/CountriesGraphqlFilter.vue'
import HireHistoryGraphqlFilter from './trustedContacts/HireHistoryGraphqlFilter.vue'
import HireStatusGraphqlFilter from './trustedContacts/HireStatusGraphqlFilter.vue'
import StatusesGraphqlFilter from './trustedContacts/StatusesGraphqlFilter.vue'
import BusinessSetupGraphqlFilter from './trustedContacts/BusinessSetupGraphqlFilter.vue'
import OriginGraphqlFilter from './trustedContacts/OriginGraphqlFilter.vue'
import SkillsGraphqlFilter from './trustedContacts/SkillsGraphqlFilter.vue'
import InvitedByGraphqlFilter from './trustedContacts/InvitedByGraphqlFilter.vue'
import AccountsGraphqlFilter from '@/components/GraphqlDataTable/filters/accounts/AccountsGraphqlFilter.vue'
import WorkersGraphqlFilter from '@/components/GraphqlDataTable/filters/accounts/WorkersGraphqlFilter.vue'
import CompaniesGraphqlFilter from '@/components/GraphqlDataTable/filters/accounts/CompaniesGraphqlFilter.vue'
import DateRangeFilter from '@/components/GraphqlDataTable/filters/Dates/DateRangeFilter.vue'
import ExternalIdentifiersGraphqlFilter from '@/components/GraphqlDataTable/filters/hires/ExternalIdentifiersGraphqlFilter.vue'
import StatusGraphqlFilter from '@/components/GraphqlDataTable/filters/hires/StatusGraphqlFilter.vue'
import EngagementTypeGraphqlFilter from '@/components/GraphqlDataTable/filters/hires/EngagementTypeGraphqlFilter.vue'
import EngagementTypeSetupGraphqlFilter from '@/components/GraphqlDataTable/filters/hires/EngagementTypeSetupGraphqlFilter.vue'
import OwnersGraphqlFilter from '@/components/GraphqlDataTable/filters/accounts/OwnersGraphqlFilter.vue'
import LocationsGraphqlFilter from '@/components/GraphqlDataTable/filters/locations/LocationsGraphqlFilter.vue'
import BooleanComp from '@/components/GraphqlDataTable/filters/Primitives/Boolean.vue'
import { FilterMaps } from '@/components/GraphqlDataTable/filters/types'
import { FilterGroups } from '@/components/GraphqlDataTable/filters/filter-enums'
import Skills from '@/components/GraphqlDataTable/filters/Primitives/Skills.vue'
import RateTypeFilter from '@/components/GraphqlDataTable/filters/Primitives/RateType.vue'
import JobStatusFilter from '@/components/GraphqlDataTable/filters/Primitives/JobStatus.vue'
import ExperienceLevelFilter from '@/components/GraphqlDataTable/filters/Primitives/ExpectedExperienceLevel.vue'
import AccountTypeFilter from '@/components/GraphqlDataTable/filters/Primitives/AccountType.vue'
import BatchItemStatusFilter from '@/components/GraphqlDataTable/filters/Primitives/BatchItemStatus.vue'
import CustomFields from '@/components/GraphqlDataTable/filters/CustomFields/CustomFields.vue'
import AssociationGraphqlFilter from '@/components/GraphqlDataTable/filters/job/AssociationGraphqlFilter.vue'
import LocationPreferencesGraphqlFilter from '@/components/GraphqlDataTable/filters/job/LocationPreferencesGraphqlFilter.vue'
import RecruiterOwnershipIsExpiredFilter from '@/components/GraphqlDataTable/filters/hires/RecruiterOwnershipIsExpiredFilter.vue'
import AssignmentCompaniesGraphqlFilter from '@/components/GraphqlDataTable/filters/hires/AssignmentCompaniesGraphqlFilter.vue'
import BidStatusGraphqlFilter from '@/components/GraphqlDataTable/filters/bids/BidStatusGraphqlFilter.vue'
import FreelancerCompaniesGraphqlFilter from '@/components/GraphqlDataTable/filters/accounts/FreelancerCompaniesGraphqlFilter.vue'
import RecruiterCompaniesGraphqlFilter from '@/components/GraphqlDataTable/filters/hires/RecruiterCompaniesGraphqlFilter.vue'
import RecruiterWorkersGraphqlFilter from '@/components/GraphqlDataTable/filters/hires/RecruiterWorkersGraphqlFilter.vue'
import RecruiterStatusGraphqlFilter from '@/components/GraphqlDataTable/filters/company-recruiter/RecruiterStatusGraphqlFilter.vue'
import RegionsGraphqlFilter from '@/components/GraphqlDataTable/filters/company-recruiter/RegionsGraphqlFilter.vue'
import EndClientsGraphqlFilter from '@/components/GraphqlDataTable/filters/company-recruiter/EndClientsGraphqlFilter.vue'
import SupplierStatusGraphqlFilter from '@/components/GraphqlDataTable/filters/supplier-client/SupplierStatusGraphqlFilter.vue'
import RecruitersGraphqlFilter from '@/components/GraphqlDataTable/filters/hires/RecruitersGraphqlFilter.vue'
import LinkedRecruitersGraphqlFilter from '@/components/GraphqlDataTable/filters/company-supplier/LinkedRecruitersGraphqlFilter.vue'
import VerifiedWorkerReviewGraphqlFilter from '@/components/GraphqlDataTable/filters/compliance/VerifiedWorkerReviewGraphqlFilter.vue'
import VerifiedRecruiterReviewGraphqlFilter from '@/components/GraphqlDataTable/filters/compliance/VerifiedRecruiterReviewGraphqlFilter.vue'
import WorkerTypeGraphqlFilter from '@/components/GraphqlDataTable/filters/trustedContacts/WorkerTypeGraphqlFilter.vue'

// Register filters here with one of two key types:
// GraphQLDataType: markRaw(GraphQLDataTypeFilterComponent)
// or $argumentName-argumentType: markRaw(ComplexFilterComponent)
// Sometimes filters can be generated on the fly or there already exists a version using a different argument name
// check them over before making a new account.
export default {
  'supplierStatuses-[RecruiterStatus!]': {
    component: markRaw(SupplierStatusGraphqlFilter),
    group: FilterGroups.Default,
  },
  'staffingAgencies-[ID!]': {
    component: markRaw(RecruitersGraphqlFilter),
    group: FilterGroups.Default,
  },
  'endClients-[ID!]': {
    component: markRaw(EndClientsGraphqlFilter),
    group: FilterGroups.Default,
  },
  'clientRegions-MarketRegionInput': {
    component: markRaw(RegionsGraphqlFilter),
    group: FilterGroups.Default,
  },
  'linkedStaffingAgencies-[ID!]': {
    component: markRaw(LinkedRecruitersGraphqlFilter),
    group: FilterGroups.Default,
  },
  'accounts-[ID!]': {
    component: markRaw(AccountsGraphqlFilter),
    group: FilterGroups.Default,
  },
  'companies-[ID!]': {
    component: markRaw(CompaniesGraphqlFilter),
    group: FilterGroups.Default,
  },
  DateRangeInput: {
    component: markRaw(DateRangeFilter),
    group: FilterGroups.Default,
  },
  'workers-[ID!]': {
    component: markRaw(WorkersGraphqlFilter),
    group: FilterGroups.Default,
  },
  'externalIdentifiers-[String!]': {
    component: markRaw(ExternalIdentifiersGraphqlFilter),
    group: FilterGroups.Default,
  },
  'activeStatus-[HireActiveStatus!]': {
    component: markRaw(StatusGraphqlFilter),
    group: FilterGroups.Default,
  },
  'statuses-[BidStatus!]': {
    component: markRaw(BidStatusGraphqlFilter),
    group: FilterGroups.Default,
  },
  'engagementType-[EngagementType!]': {
    component: markRaw(EngagementTypeGraphqlFilter),
    group: FilterGroups.Default,
  },
  'engagementTypeSetup-[EngagementTypeSetup!]': {
    component: markRaw(EngagementTypeSetupGraphqlFilter),
    group: FilterGroups.Default,
  },
  'usesClassification-[ClassificationUsage!]': {
    component: markRaw(ClassificationUsageGraphqlFilter),
    group: FilterGroups.Default,
  },
  'jobOwners-[ID!]': {
    component: markRaw(OwnersGraphqlFilter),
    group: FilterGroups.Default,
  },
  'hireOwners-[ID!]': {
    component: markRaw(OwnersGraphqlFilter),
    group: FilterGroups.HireDetails,
  },
  'hiringManagers-[ID!]': {
    component: markRaw(OwnersGraphqlFilter),
    group: FilterGroups.Default,
  },
  'clientOwners-[ID!]': {
    component: markRaw(OwnersGraphqlFilter),
    group: FilterGroups.Default,
  },
  'locations-[String!]': {
    component: markRaw(LocationsGraphqlFilter),
    group: FilterGroups.Default,
  },
  Boolean: {
    component: markRaw(BooleanComp),
    group: FilterGroups.Default,
  },
  '[Currency!]': {
    group: FilterGroups.HireDetails,
  },
  '[RateType!]': {
    component: markRaw(RateTypeFilter),
    group: FilterGroups.HireDetails,
  },
  'jobRateTypes-[RateType!]': {
    component: markRaw(RateTypeFilter),
    group: FilterGroups.JobPostDetails,
  },
  'requestTypes-[PaymentRequestType!]': {
    component: markRaw(PaymentRequestTypeGraphqlFilter),
    group: FilterGroups.Default,
  },
  'statuses-[PaymentRequestStatus!]': {
    component: markRaw(PaymentRequestStatusGraphqlFilter),
    group: FilterGroups.Default,
  },
  'clients-[ID!]': {
    component: markRaw(ClientsGraphqlFilter),
    group: FilterGroups.Default,
  },
  'completed-Boolean': {
    group: FilterGroups.Default,
  },
  '[Association!]': {
    component: markRaw(AssociationGraphqlFilter),
    group: FilterGroups.JobPostDetails,
  },
  '[LocationPreference!]': {
    component: markRaw(LocationPreferencesGraphqlFilter),
    group: FilterGroups.JobPostDetails,
  },
  'skills-[String!]': {
    component: markRaw(Skills),
    group: FilterGroups.Default,
  },
  'skills-[ID!]': {
    component: markRaw(SkillsGraphqlFilter),
    group: FilterGroups.Default,
  },
  '[ExpectedExperienceLevel!]': {
    component: markRaw(ExperienceLevelFilter),
    group: FilterGroups.JobPostDetails,
  },
  '[JobStatus!]': {
    component: markRaw(JobStatusFilter),
    group: FilterGroups.Default,
  },
  '[BatchItemStatus!]': {
    component: markRaw(BatchItemStatusFilter),
    group: FilterGroups.Default,
  },
  '[AccountType!]': {
    component: markRaw(AccountTypeFilter),
    group: FilterGroups.Default,
  },
  '[CustomFieldTypeValueInput!]': {
    component: markRaw(CustomFields),
    group: FilterGroups.NoGroup,
  },
  'recruiterOwnershipIsExpired-Boolean': {
    component: markRaw(RecruiterOwnershipIsExpiredFilter),
    group: FilterGroups.NoGroup,
  },
  'assignmentCompanies-[ID!]': {
    component: markRaw(AssignmentCompaniesGraphqlFilter),
    group: FilterGroups.Default,
  },
  'clientCompanies-[ID!]': {
    component: markRaw(FreelancerCompaniesGraphqlFilter),
    group: FilterGroups.Default,
  },
  'recruiterCompanies-[ID!]': {
    component: markRaw(RecruiterCompaniesGraphqlFilter),
    group: FilterGroups.Default,
  },
  'recruiterWorkers-[ID!]': {
    component: markRaw(RecruiterWorkersGraphqlFilter),
    group: FilterGroups.Default,
  },
  'workerPayoutStatuses-[PaymentRequestWorkerPayoutStatus!]': {
    component: markRaw(WorkerPayoutStatusGraphqlFilter),
    group: FilterGroups.Default,
  },
  'hasTimesheet-Boolean': {
    component: markRaw(HasTimesheetGraphqlFilter),
    group: FilterGroups.Default,
  },
  'hasPurchaseOrderNumber-Boolean': {
    component: markRaw(HasPurchaseOrderNumberGraphqlFilter),
    group: FilterGroups.Default,
  },
  'statuses-[RecruiterStatus!]': {
    component: markRaw(RecruiterStatusGraphqlFilter),
    group: FilterGroups.Default,
  },
  'recruiterRegions-MarketRegionInput': {
    component: markRaw(RegionsGraphqlFilter),
    group: FilterGroups.Default,
  },
  'contactRegions-MarketRegionInput': {
    component: markRaw(RegionsGraphqlFilter),
    group: FilterGroups.Default,
  },
  'countries-[String!]': {
    component: markRaw(CountriesGraphqlFilter),
    group: FilterGroups.Default,
  },
  'hireHistory-HireHistoryFilterInput': {
    component: markRaw(HireHistoryGraphqlFilter),
    group: FilterGroups.Default,
  },
  'hireStatus-HireStatusFilterInput': {
    component: markRaw(HireStatusGraphqlFilter),
    group: FilterGroups.Default,
  },
  'statuses-[ContactStatus!]': {
    component: markRaw(StatusesGraphqlFilter) as any,
    group: FilterGroups.Default,
  },
  'businessSetup-[BusinessEntityType!]': {
    component: markRaw(BusinessSetupGraphqlFilter) as any,
    group: FilterGroups.Default,
  },
  'origin-TrustedContactOrigin': {
    component: markRaw(OriginGraphqlFilter) as any,
    group: FilterGroups.Default,
  },
  'invitedByUsers-InvitedByInput': {
    component: markRaw(InvitedByGraphqlFilter) as any,
    group: FilterGroups.Default,
  },
  'verifiedWorkerReview-VerifiedWorkerReviewFilterInput': {
    component: markRaw(VerifiedWorkerReviewGraphqlFilter) as any,
    group: FilterGroups.Default,
  },
  'verifiedRecruiterReview-VerifiedRecruiterReviewFilterInput': {
    component: markRaw(VerifiedRecruiterReviewGraphqlFilter) as any,
    group: FilterGroups.Default,
  },
  'managedStatus-TrustedContactManagedStatus': {
    component: markRaw(WorkerTypeGraphqlFilter) as any,
    group: FilterGroups.Default,
  },
} satisfies FilterMaps as FilterMaps
